import { load } from "@porsche-design-system/components-js";

export default function (): void {
  load({ prefix: "phn" });
}
